import utils from "@/stuff/Utils";
import { mapData } from "@/stuff/DataMapping";
import { ResponseSetStatus } from "@/model/Enums";

export interface IMatrixModule {
    id: number; 
    supplierID: number; 
    description: string;
    expires: Date;
    latestStatus: ResponseSetStatus;
    notApplicable: boolean;
}

export class MatrixModule implements IMatrixModule {

    constructor(data?: IMatrixModule) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IMatrixModule) {
        mapData(data, { root: () => this });
    }

    id = 0; 
    supplierID = 0; 
    description = "";
    expires = new Date(utils.emptyDateValue);
    latestStatus: ResponseSetStatus = ResponseSetStatus.None;
    notApplicable: boolean = false;
}
